import useDebounce from "hooks/others/useDebounce";
import { useInfiniteQuery, useQueryClient } from "react-query";
import { GetOfficalHolidays } from "services/workSchedule";

export default function useGetOfficalHolidays(obj: { search: string;}) {
    const { newParam: searchParam } = useDebounce(obj.search);
    const queryKey = ["offical-holidays",searchParam];
    return useInfiniteQuery(
        queryKey,
        async ({ pageParam = 1 }) => GetOfficalHolidays(pageParam, searchParam),
        {
            getNextPageParam: (lastPage) =>
            {
                return lastPage.meta.nextPageUrl ? lastPage.meta.currentPage + 1 : undefined
            }
        }
    );
}





